(function () {
  const instances = new Map();

  function init(section) {
    const id = section.dataset.sectionId;
    if (instances.has(id)) return;

     window.themePricingBundlesAddToCart = function(event) {
    event.preventDefault();
    var id = event.currentTarget.getAttribute('data-native-button-id');
    if (!id) return;
    var nativeBtn = document.getElementById(id);
    if (nativeBtn) nativeBtn.click();
  };

    instances.set(id, true);
  }

  document.addEventListener('section:fea2-collection:load', (e) => {
    init(e.detail);
  });
})();
